import { render, staticRenderFns } from "./OverviewShowcaseGroup copy.vue?vue&type=template&id=1941ac82&scoped=true"
import script from "./OverviewShowcaseGroup copy.vue?vue&type=script&lang=js"
export * from "./OverviewShowcaseGroup copy.vue?vue&type=script&lang=js"
import style0 from "./OverviewShowcaseGroup copy.vue?vue&type=style&index=0&id=1941ac82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941ac82",
  null
  
)

export default component.exports